module.exports = __webpack_public_path__ + "img/horizontal_7_4_7016.c927a052.png";